<template>
  <div class="mt-2 mb-1 text-left crt-deal-create">
    <b-row>
      <!--Stacr-->
      <b-col cols="4">
        <!--modelStacr.ats.Name-->
        <b-form-group
          label-cols="6"
          label-cols-lg="4"
          :label="mDealStacr.vocDbToLabel('Name')"
          class="text-left mb-2"
        >
          <b-input-group>
            <b-form-input
              v-model="modelStacr.ats.Name"
              :state="validationStatus('STACR.Name')"
              class="text-right"
              style="min-width: 2em"
              placeholder="e.g. STACR 2022-01-SUFFIX"
              required
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ validationMessage("STACR.Name") }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-col>

      <!--CRUD buttons-->
      <b-col cols="4">
        <b-row>
          <b-btn
            variant="primary"
            class="buttons_row-button buttons_row--spaced"
            @click="validateModelWithUINotification"
            >Validate</b-btn
          >
          <b-btn
            variant="primary"
            class="buttons_row-button buttons_row--spaced"
            v-if="dealId$ == null"
            @click="createOrUpdateDeal()"
            >Create</b-btn
          >
          <b-btn
            variant="primary"
            class="buttons_row-button buttons_row--spaced"
            v-if="dealId$ != null"
            @click="createOrUpdateDeal({ isDealCreation: false })"
            >Update</b-btn
          >
          <b-btn
            variant="primary"
            class="buttons_row--spaced"
            v-if="dealId$ != null"
            @click="
              createOrUpdateDeal({ isDealCreation: true, isDealClone: true })
            "
            >Clone</b-btn
          >
          <b-btn
            variant="info"
            class="buttons_row-button buttons_row--spaced"
            v-if="dealId$ != null"
            @click="deleteDeal()"
            >Delete</b-btn
          >
        </b-row>
        <b-row>
          <router-link
            v-if="dealId$ != null && this.modelStacr.Name$ != null"
            :to="{
              path: '/deal_analysis',
              query: { dealName: this.modelStacr.Name$ },
            }"
            class="btn btn-info buttons_row-button buttons_row--spaced"
            >Goto STACR</router-link
          >
          <router-link
            v-if="dealId$ != null && this.modelAcis.Name$ != null"
            :to="{
              path: '/acis_analysis',
              query: { dealName: this.modelAcis.Name$ },
            }"
            class="btn btn-info buttons_row-button buttons_row--spaced"
            >Goto ACIS</router-link
          >
        </b-row>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <!--modelStacr.ats.CollateralInformation{}-->
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            STACR Collateral Information
          </caption>

          <!--modelStacr.ats.CollateralInformation.ReferencePoolBalance-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="
              mDealStacr.vocDbToLabel(
                'CollateralInformation.ReferencePoolBalance'
              )
            "
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="
                  modelStacr.ats.CollateralInformation[0].ats
                    .ReferencePoolBalance
                "
                :state="
                  validationStatus(
                    'STACR.CollateralInformation.ReferencePoolBalance'
                  )
                "
                @change="onReferencePoolBalanceChanges"
                class="text-right"
                maxSignsAfterDot="2"
                :formatter="formatNumber"
                lazy-formatter
                style="min-width: 2em"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{
                  validationMessage(
                    "STACR.CollateralInformation[0].ReferencePoolBalance"
                  )
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.CollateralInformation.Wac-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('CollateralInformation.Wac')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="modelStacr.ats.CollateralInformation[0].ats.Wac"
                :state="validationStatus('STACR.CollateralInformation.Wac')"
                class="text-right"
                :formatter="formatNumber"
                lazy-formatter
                maxSignsAfterDot="8"
                style="min-width: 2em"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validationMessage("STACR.CollateralInformation.Wac") }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.CollateralInformation.Wam-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('CollateralInformation.Wam')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="modelStacr.ats.CollateralInformation[0].ats.Wam"
                :state="validationStatus('STACR.CollateralInformation.Wam')"
                class="text-right"
                style="min-width: 2em"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validationMessage("STACR.CollateralInformation.Wam") }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.CollateralInformation.Wala-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('CollateralInformation.Wala')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="modelStacr.ats.CollateralInformation[0].ats.Wala"
                :state="validationStatus('STACR.CollateralInformation.Wala')"
                class="text-right"
                style="min-width: 2em"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validationMessage("STACR.CollateralInformation.Wala") }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </table>
      </b-col>

      <!--Structure-->
      <b-col>
        <!--modelStacr.ats.Structure{}-->
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            STACR Structure
          </caption>

          <!--modelStacr.ats.Structure.CETarget-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('Structure.CETarget')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="modelStacr.ats.Structure.CETarget"
                :state="validationStatus('STACR.Structure.CETarget')"
                class="text-right"
                :formatter="formatNumber"
                lazy-formatter
                maxSignsAfterDot="8"
                style="min-width: 2em"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validationMessage("STACR.Structure.CETarget") }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.Structure.DlqTarget-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('Structure.DlqTarget')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="modelStacr.ats.Structure.DlqTarget"
                :state="validationStatus('STACR.Structure.DlqTarget')"
                class="text-right"
                :formatter="formatNumber"
                lazy-formatter
                maxSignsAfterDot="8"
                style="min-width: 2em"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validationMessage("STACR.Structure.DlqTarget") }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.Structure.DlqMonthsAverage-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('Structure.DlqMonthsAverage')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="modelStacr.ats.Structure.DlqMonthsAverage"
                :state="validationStatus('STACR.Structure.DlqMonthsAverage')"
                :formatter="formatNumber"
                lazy-formatter
                minSignsAfterDot="0"
                maxSignsAfterDot="0"
                class="text-right"
                style="min-width: 2em"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validationMessage("STACR.Structure.DlqMonthsAverage") }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.Structure.UseCumLossTest-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('Structure.UseCumLossTest')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-checkbox
                v-model="modelStacr.ats.Structure.UseCumLossTest"
                :state="validationStatus('STACR.Structure.UseCumLossTest')"
                :value="true"
                :unchecked-value="false"
                class="text-right"
              ></b-form-checkbox>
              <b-form-invalid-feedback>
                {{ validationMessage("STACR.Structure.UseCumLossTest") }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </table>

        <!--modelAcis.ats.Structure{}-->
        <!--mDealAcis-->
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            ACIS Structure
          </caption>

          <!--modelAcis.ats.Structure.EffectiveDate-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealAcis.vocDbToLabel('Structure.EffectiveDate')"
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                v-model="modelAcis.Structure.EffectiveDate$"
                :class="{
                  'border border-danger': !validationStatusBoolean(
                    'ACIS.Structure.EffectiveDate'
                  ),
                }"
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
              />
              <small
                v-if="!validationStatusBoolean('ACIS.Structure.EffectiveDate')"
                class="text-danger text-sm"
                >{{ validationMessage("ACIS.Structure.EffectiveDate") }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--modelAcis.ats.Structure.MaturityDate-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealAcis.vocDbToLabel('Structure.MaturityDate')"
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                v-model="modelAcis.Structure.MaturityDate$"
                :class="{
                  'border border-danger': !validationStatusBoolean(
                    'ACIS.Structure.MaturityDate'
                  ),
                }"
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
              />
              <small
                v-if="!validationStatusBoolean('ACIS.Structure.MaturityDate')"
                class="text-danger text-sm"
                >{{ validationMessage("ACIS.Structure.MaturityDate") }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--modelAcis.ats.Structure.MonthsToCall-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealAcis.vocDbToLabel('Structure.MonthsToCall')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="modelAcis.ats.Structure.MonthsToCall"
                :state="validationStatus('ACIS.Structure.MonthsToCall')"
                class="text-right"
                style="min-width: 2em"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validationMessage("ACIS.Structure.MonthsToCall") }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </table>
      </b-col>

      <!--modelStacr.ats.ContractInformation{}-->
      <b-col>
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            STACR Contract Information
          </caption>

          <!--modelStacr.ats.ContractInformation.ClosingDate-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('ContractInformation.ClosingDate')"
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                v-model="modelStacr.ContractInformation.ClosingDate$"
                :class="{
                  'border border-danger': !validationStatusBoolean(
                    'STACR.ContractInformation.ClosingDate'
                  ),
                }"
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
                @change="onStacrDatesChanges($event)"
              />
              <small
                v-if="
                  !validationStatusBoolean(
                    'STACR.ContractInformation.ClosingDate'
                  )
                "
                class="text-danger text-sm"
                >{{
                  validationMessage("STACR.ContractInformation.ClosingDate")
                }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.ContractInformation.FirstPayDate-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('ContractInformation.FirstPayDate')"
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                v-model="modelStacr.ContractInformation.FirstPayDate$"
                :class="{
                  'border border-danger': !validationStatusBoolean(
                    'STACR.ContractInformation.FirstPayDate'
                  ),
                }"
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
                @change="onStacrDatesChanges($event)"
              />
              <small
                v-if="
                  !validationStatusBoolean(
                    'STACR.ContractInformation.FirstPayDate'
                  )
                "
                class="text-danger text-sm"
                >{{
                  validationMessage("STACR.ContractInformation.FirstPayDate")
                }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.ContractInformation.MaturityDate-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealStacr.vocDbToLabel('ContractInformation.MaturityDate')"
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                v-model="modelStacr.ContractInformation.MaturityDate$"
                :class="{
                  'border border-danger': !validationStatusBoolean(
                    'STACR.ContractInformation.MaturityDate'
                  ),
                }"
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
                @change="onStacrDatesChanges($event)"
              />
              <small
                v-if="
                  !validationStatusBoolean(
                    'STACR.ContractInformation.MaturityDate'
                  )
                "
                class="text-danger text-sm"
                >{{
                  validationMessage("STACR.ContractInformation.MaturityDate")
                }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.ContractInformation.EarlyRedemptionDate-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="
              mDealStacr.vocDbToLabel('ContractInformation.EarlyRedemptionDate')
            "
            class="text-left mb-2"
          >
            <b-input-group>
              <datepicker
                v-model="modelStacr.ContractInformation.EarlyRedemptionDate$"
                :class="{
                  'border border-danger': !validationStatusBoolean(
                    'STACR.ContractInformation.EarlyRedemptionDate'
                  ),
                }"
                :clearable="false"
                class="w-100"
                input-class="form-control text-right calculation-settings-input"
                type="date"
                format="MM/DD/YYYY"
                lang="en"
                @change="onStacrDatesChanges($event)"
              />
              <small
                v-if="
                  !validationStatusBoolean(
                    'STACR.ContractInformation.EarlyRedemptionDate'
                  )
                "
                class="text-danger text-sm"
                >{{
                  validationMessage(
                    "STACR.ContractInformation.EarlyRedemptionDate"
                  )
                }}</small
              >
            </b-input-group>
          </b-form-group>

          <!--modelStacr.ats.ContractInformation.CancellationPct-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="
              mDealStacr.vocDbToLabel('ContractInformation.CancellationPct')
            "
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="modelStacr.ContractInformation.CancellationPct$"
                :state="
                  validationStatus('STACR.ContractInformation.CancellationPct')
                "
                class="text-right"
                :formatter="formatNumber"
                lazy-formatter
                maxSignsAfterDot="8"
                style="min-width: 2em"
              ></b-form-input>
              <b-input-group-append>
                <!--<span class="btn disabled">%</span>-->
              </b-input-group-append>
              <b-form-invalid-feedback>
                {{
                  validationMessage("STACR.ContractInformation.CancellationPct")
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </table>

        <table class="table table-sm color mb-2 mt-5">
          <caption class="caption table-caption mb-2">
            ACIS Name
          </caption>

          <!--modelAcis.ats.Name-->
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            :label="mDealAcis.vocDbToLabel('Name')"
            class="text-left mb-2"
          >
            <b-input-group>
              <b-form-input
                v-model="modelAcis.ats.Name"
                :state="validationStatus('ACIS.Name')"
                placeholder="e.g. ACIS 2022-01-SUFFIX"
                class="text-right"
                style="min-width: 2em"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ validationMessage("ACIS.Name") }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <!--modelStacr.ats.Liability[]-->
        <!--mDealStacrLiability-->
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            STACR Liability Description
          </caption>
          <thead class="header">
            <tr>
              <th>{{ mDealStacrLiability.vocDbToLabel("BondName") }}</th>
              <th>{{ mDealStacrLiability.vocDbToLabel("Detachment") }}</th>
              <th>{{ mDealStacrLiability.vocDbToLabel("Thickness") }}</th>
              <th>{{ mDealStacrLiability.vocDbToLabel("Balance") }}</th>
              <th>{{ mDealStacrLiability.vocDbToLabel("Coupon") }}</th>
              <th>{{ mDealStacrLiability.vocDbToLabel("Spread") }}</th>
            </tr>
          </thead>
          <tbody>
            <!--modelStacr.ats.Liability[]-->
            <tr v-for="(item, idx) of modelStacr.ats.Liability">
              <td>
                <!--item.ats.BondName-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      :disabled="idx == 0"
                      v-model="item.BondName$"
                      :state="
                        validationStatus(`STACR.Liability.${idx}.BondName`)
                      "
                      class="text-right"
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                      @change="onStacrLiabilityChanges(idx, 'BondName')"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{ validationMessage(`STACR.Liability.${idx}.BondName`) }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
              <td>
                <!--item.ats.Detachment-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      :disabled="idx == 0"
                      v-model="item.ats.Detachment"
                      :state="
                        validationStatus(`STACR.Liability.${idx}.Detachment`)
                      "
                      class="text-right"
                      :formatter="formatNumber"
                      lazy-formatter
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                      @change="onStacrLiabilityChanges(idx)"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{
                        validationMessage(`STACR.Liability.${idx}.Detachment`)
                      }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
              <td>
                <!--item.ats.Thickness-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      disabled
                      v-model="item.ats.Thickness"
                      :state="
                        validationStatus(`STACR.Liability.${idx}.Thickness`)
                      "
                      class="text-right"
                      :formatter="formatNumber"
                      lazy-formatter
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{
                        validationMessage(`STACR.Liability.${idx}.Thickness`)
                      }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
              <td>
                <!--item.ats.Balance-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      disabled
                      v-model="item.ats.Balance"
                      :state="
                        validationStatus(`STACR.Liability.${idx}.Balance`)
                      "
                      class="text-right"
                      :formatter="formatNumber"
                      lazy-formatter
                      maxSignsAfterDot="2"
                      style="min-width: 2em"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{ validationMessage(`STACR.Liability.${idx}.Balance`) }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
              <td>
                <!--item.ats.Coupon-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="item.ats.Coupon"
                      :state="validationStatus(`STACR.Liability.${idx}.Coupon`)"
                      class="text-right"
                      :formatter="formatNumber"
                      lazy-formatter
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{ validationMessage(`STACR.Liability.${idx}.Coupon`) }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
              <td>
                <!--item.ats.Spread-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="item.ats.Spread"
                      :state="validationStatus(`STACR.Liability.${idx}.Spread`)"
                      class="text-right"
                      :formatter="formatNumber"
                      lazy-formatter
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{ validationMessage(`STACR.Liability.${idx}.Spread`) }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
      <b-col cols="auto" class="text-center p-0">
        <div>
          <b-btn variant="info" class="mb-2" @click="addLiabilityItem">
            <i class="fas fa-plus"></i>
          </b-btn>
        </div>
        <div>
          <b-btn
            :disabled="this.modelStacr.ats.Liability.length === 1"
            variant="info"
            class="mb-2"
            @click="removeLiabilityItem"
          >
            <i class="fas fa-minus"></i>
          </b-btn>
        </div>
      </b-col>
      <b-col>
        <!--modelAcis.ats.Liability[]-->
        <!--mDealAcisLiability-->
        <table class="table table-sm color mb-2">
          <caption class="caption table-caption mb-2">
            ACIS Liability Description
          </caption>
          <thead class="header">
            <tr>
              <th>{{ mDealAcisLiability.vocDbToLabel("BondName") }}</th>
              <th>{{ mDealAcisLiability.vocDbToLabel("OfferedPct") }}</th>
              <th>{{ mDealAcisLiability.vocDbToLabel("Balance") }}</th>
              <th>{{ mDealAcisLiability.vocDbToLabel("Premium") }}</th>
              <th>{{ mDealAcisLiability.vocDbToLabel("CallMultiplier") }}</th>
            </tr>
          </thead>
          <tbody>
            <!--modelAcis.ats.Liability[]-->
            <tr v-for="(item, idx) of modelAcis.ats.Liability">
              <td>
                <!--item.ats.BondName-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      disabled
                      v-model="item.BondName$"
                      :state="
                        idx === 0
                          ? null
                          : validationStatus(`ACIS.Liability.${idx}.BondName`)
                      "
                      class="text-right"
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback v-if="idx !== 0">
                      {{ validationMessage(`ACIS.Liability.${idx}.BondName`) }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
              <td>
                <!--item.ats.OfferedPct-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      :disabled="idx == 0"
                      v-model="item.ats.OfferedPct"
                      :state="
                        validationStatus(`ACIS.Liability.${idx}.OfferedPct`)
                      "
                      class="text-right"
                      :formatter="formatNumber"
                      lazy-formatter
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                      @change="
                        modelAcis.calculateAutoFields(
                          idx,
                          modelStacr.ats.Liability[idx]
                        )
                      "
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{
                        validationMessage(`ACIS.Liability.${idx}.OfferedPct`)
                      }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
              <td>
                <!--item.ats.Balance-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      disabled
                      v-model="item.ats.Balance"
                      :state="validationStatus(`ACIS.Liability.${idx}.Balance`)"
                      class="text-right"
                      :formatter="formatNumber"
                      lazy-formatter
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{ validationMessage(`ACIS.Liability.${idx}.Balance`) }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
              <td>
                <!--item.ats.Premium-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      :disabled="idx == 0"
                      v-model="item.ats.Premium"
                      :state="validationStatus(`ACIS.Liability.${idx}.Premium`)"
                      class="text-right"
                      :formatter="formatNumber"
                      lazy-formatter
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{ validationMessage(`ACIS.Liability.${idx}.Premium`) }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
              <td>
                <!--item.ats.CallMultiplier-->
                <b-form-group
                  label-cols="0"
                  label-cols-lg="0"
                  label=""
                  class="text-left mb-2"
                >
                  <b-input-group>
                    <b-form-input
                      :disabled="idx == 0"
                      v-model="item.ats.CallMultiplier"
                      :state="
                        validationStatus(`ACIS.Liability.${idx}.CallMultiplier`)
                      "
                      class="text-right"
                      :formatter="formatNumber"
                      lazy-formatter
                      maxSignsAfterDot="8"
                      style="min-width: 2em"
                    ></b-form-input>
                    <b-input-group-append>
                      <!--<span class="btn disabled">%</span>-->
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      {{
                        validationMessage(
                          `ACIS.Liability.${idx}.CallMultiplier`
                        )
                      }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn
          variant="info"
          class="buttons_row-button buttons_row--spaced"
          v-if="dealId$ != null"
          @click="exportDealToODF()"
          >Export to ODF</b-btn
        >
        <b-btn
          variant="info"
          class="buttons_row-button buttons_row--spaced"
          v-if="dealId$ != null"
          @click="exportDealToXLSX()"
          >Export to XLSX</b-btn
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { AxiosSaveContentToFile } from "@/utilities/AxiosHelper";

import XLSX from "xlsx";
import { CellWriters as cw } from "@/utilities/ExcelSupport";

import mDealAcis from "@/models/mDealAcis";
import mDealAcisLiability from "@/models/mDealAcisLiability";
import mDealStacr from "@/models/mDealStacr";
import mDealStacrLiability from "@/models/mDealStacrLiability";
import mDealStacrCollateralInformation from "@/models/mDealStacrCollateralInformation";

import Datepicker from "vue2-datepicker";
import ObjAlertState from "@/components/common/alert/ObjAlertState";
import { arrayElRemoveByIndex } from "@/utilities/ArrayUtils";
import formatter from "@/utilities/Formatter";
import UtilsData from "@/utilities/UtilsData";

import service from "@/services/HttpRequestService";
import { withUINotification } from "@/hooks/UserNotifications";
import UtilsObject from "@/utilities/UtilsObject";

import { generateDealCloneName } from "./dealsNameGenerator";

export default {
  name: "AcisDealEditor",
  props: {
    dealId: {
      type: String | Number,
      default: null,
    },
  },
  data() {
    return {
      createdDealId: null,
      mDealStacr,
      mDealStacrLiability,
      mDealStacrCollateralInformation,
      mDealAcis,
      mDealAcisLiability,
      modelAcis: new mDealAcis(),
      modelStacr: new mDealStacr(),
      validation: {},
    };
  },
  async created() {
    if (this.dealId$) {
      await this.loadDealDetailsById(this.dealId$);
      return;
    }
    this.calculateAutoFields();
  },
  computed: {
    dealId$() {
      return this.createdDealId ?? this.dealId;
    },
  },
  watch: {
    $route(to, from) {
      const { query: { dealId = null } = {} } = to;
      if (dealId != null) {
        this.loadDealDetailsById(dealId);
      }
    },
  },
  methods: {
    calculateAutoFields() {
      this.modelStacr.calculateAutoFields();
      for (const [
        idx,
        stacrLiabilityItem,
      ] of this.modelStacr.ats.Liability.entries()) {
        if (idx !== 0) {
          this.modelAcis.calculateAutoFields(idx, stacrLiabilityItem);
        }
      }
    },
    async loadDealDetailsById(dealId) {
      const operationResult = await withUINotification.bind(this)(async () => {
        const {
          data: { Name = null, Structure: Structure = {} },
        } = await service.getCustomDeal(dealId);
        const dealStructure = JSON.parse(Structure);
        this.modelStacr.setRawFields(dealStructure.STACR ?? {});
        this.modelAcis.setRawFields(dealStructure.ACIS ?? {});
      }, `Failed to get the deal structure. Id: ${dealId}.`);
      if (operationResult) {
        for (const [
          idx,
          stacrLiabilityItem,
        ] of this.modelStacr.ats.Liability.entries()) {
          if (idx !== 0) {
            this.modelAcis.calculateAutoFields(idx, stacrLiabilityItem);
          }
        }
      }
    },
    addLiabilityItem() {
      this.modelStacr.ats.Liability.push(
        new mDealStacrLiability({
          BondName: `M-${this.modelStacr.ats.Liability.length}`,
        })
      );
      this.modelAcis.ats.Liability.push(new mDealAcisLiability());
      this.onStacrLiabilityChanges(this.modelAcis.ats.Liability.length - 1);
    },
    removeLiabilityItem(idx) {
      if (this.modelStacr.ats.Liability.length > 1) {
        arrayElRemoveByIndex(
          this.modelStacr.ats.Liability,
          this.modelStacr.ats.Liability.length - 1
        );
      }
      if (this.modelAcis.ats.Liability.length > 1) {
        arrayElRemoveByIndex(
          this.modelAcis.ats.Liability,
          this.modelAcis.ats.Liability.length - 1
        );
      }
      if (this.modelAcis.ats.Liability.length > 1) {
        this.onStacrLiabilityChanges(this.modelAcis.ats.Liability.length - 1);
      }
    },
    onStacrLiabilityChanges(idx, changesSource = "Detachment") {
      switch (changesSource) {
        case "Detachment":
          this.modelStacr.calculateAutoFields();
          this.modelAcis.calculateAutoFields(
            idx,
            this.modelStacr.ats.Liability[idx]
          );
          idx - 1 > 0 && idx - 1 < this.modelStacr.ats.Liability.length
            ? this.modelAcis.calculateAutoFields(
                idx - 1,
                this.modelStacr.ats.Liability[idx - 1]
              )
            : "";
          break;
        default:
          this.modelAcis.calculateAutoFields(
            idx,
            this.modelStacr.ats.Liability[idx]
          );
      }
    },
    onStacrDatesChanges(event) {
      let {
        ClosingDate$: closingDate,
        FirstPayDate$: firstPayDate,
        MaturityDate$: maturityDate,
        EarlyRedemptionDate$: earlyRedemptionDate,
      } = this.modelStacr.ContractInformation;

      const firstPayDateMonth = firstPayDate.getMonth();
      const closingDateMonth = closingDate.getMonth();
      /*
      where 'Closing Date'  < First Pay Date < 'Maturity Date'
      BUT the month must be the same MONTH
      (or within 2 months of) the 'Closing Date' and the DAY must be the 25th.
      For example,
      if Closing is 10/1/2021, the first payment
      date may ONLY be 1/25/2021, 2/25/2021, or 3/25/2021.
*/
      const monthDifference = moment(firstPayDate).diff(
        closingDate,
        "months",
        true
      );
      if (!(monthDifference >= 0 && monthDifference <= 3)) {
        firstPayDate = moment(closingDate)
          .month(closingDate.getMonth() + 1)
          .date(25)
          .toDate();
      } else {
        firstPayDate = moment(firstPayDate).date(25).toDate();
      }

      /*
      'Early Redemption Date' is a date,
      where 'Closing Date' < 'First Payment Date' < Early Redemption Date <  'Maturity Date'…
      and defines the date on which the ACIS Contract may be cancelled… NO default.
*/
      if (!(firstPayDate.getTime() < earlyRedemptionDate.getTime())) {
        earlyRedemptionDate = moment(firstPayDate).add(1, "month").toDate();
      }

      if (!(earlyRedemptionDate.getTime() < maturityDate.getTime())) {
        maturityDate = moment(earlyRedemptionDate).add(1, "month").toDate();
      }

      // Do not use the smart properties, since the values are already JS Dates
      this.modelStacr.ats.ContractInformation.ClosingDate = closingDate;
      this.modelStacr.ats.ContractInformation.FirstPayDate = firstPayDate;
      this.modelStacr.ats.ContractInformation.EarlyRedemptionDate =
        earlyRedemptionDate;
      this.modelStacr.ats.ContractInformation.MaturityDate = maturityDate;
    },
    onReferencePoolBalanceChanges(event) {
      this.calculateAutoFields();
    },
    validationMessage(path) {
      return UtilsObject.getByPath(this.validation, path);
    },
    validationStatus(path) {
      const validationStatus = UtilsObject.getByPath(this.validation, path);
      return validationStatus == null ? null : !!!validationStatus;
    },
    validationStatusBoolean(path) {
      const validationStatus = UtilsObject.getByPath(this.validation, path);
      return validationStatus == null ? true : !!!validationStatus;
    },
    async validateModelWithUINotification() {
      await withUINotification.bind(this)(
        async () => {
          if (!this.validateModel()) {
            throw new Error();
          }
        },
        `Invalid data, Deal cannot be created.`,
        `Deal validation succeeded.`
      );
    },
    validateModel() {
      const modelStacrRaw = this.modelStacr.getRawFieldsFormattedForBackEnd();
      const modelAcisRaw = this.modelAcis.getRawFieldsFormattedForBackEnd();

      this.validation = {
        STACR: {},
        ACIS: {},
      };

      this.modelStacr.validate();
      this.modelAcis.validate();

      let validationStatus =
        this.modelStacr._localValidationStatus &&
        this.modelAcis._localValidationStatus;

      if (!validationStatus) {
        for (const { modelName, fieldSysName, msg } of [
          ...this.modelStacr._localValidationResults,
          ...this.modelAcis._localValidationResults,
        ]) {
          UtilsObject.setByPath(this.validation[modelName], fieldSysName, msg);
        }
      }

      const STACRDealNameMatch = this.modelStacr.Name$.match(/STACR\s(.+)/);
      const ACISDealNameMatch = this.modelAcis.Name$.match(/ACIS\s(.+)/);
      const STACRDealNameWithoutPrefix =
        STACRDealNameMatch?.length > 1 ? STACRDealNameMatch[1] : null;
      const ACISDealNameWithoutPrefix =
        ACISDealNameMatch?.length > 1 ? ACISDealNameMatch[1] : null;
      if (STACRDealNameWithoutPrefix != ACISDealNameWithoutPrefix) {
        UtilsObject.setByPath(
          this.validation.ACIS,
          "Name",
          `Should be 'ACIS ${STACRDealNameWithoutPrefix}'`
        );
        validationStatus = false;
      }

      if (!validationStatus) {
        this.$forceUpdate();
      }

      return validationStatus;
    },
    async createOrUpdateDeal(options = {}) {
      const { isDealCreation = true, isDealClone = false } = options;
      const clonedStacrName = generateDealCloneName(this.modelStacr.Name$);
      const clonedAcisName = generateDealCloneName(this.modelAcis.Name$);

      const dealName = isDealClone ? clonedStacrName : this.modelStacr.Name$;

      const isOperationSuccessful = await withUINotification.bind(this)(
        async () => {
          if (!this.validateModel()) {
            //throw new Error("Invalid data, Deal cannot be created.");
          }

          const stacr = this.modelStacr.getRawFieldsFormattedForBackEnd();
          const acis = this.modelAcis.getRawFieldsFormattedForBackEnd();

          if (isDealClone) {
            stacr.Name = clonedStacrName;
            acis.Name = clonedAcisName;
          }

          const dealPayload = {
            Type: "STACR_ACIS",
            Name: dealName,
            DependantNames: acis.Name,
            STACR: stacr,
            ACIS: acis,
          };

          if (isDealCreation) {
            const { data: { Id = null } = {} } =
              await service.createCustomSTACRACISDeal(dealPayload);
            if (Id == null) {
              throw new Error("Failed to generate Id for a new deal.");
            }
            this.createdDealId = Id;
          } else {
            await service.updateCustomSTACRACISDeal(this.dealId$, dealPayload);
          }
        },
        `Failed to ${isDealCreation ? "create" : "update"} the deal${
          dealName?.length ? " " + dealName + "." : "."
        }`,
        `Custom STACR/ACIS deal ${dealName} has been ${
          isDealCreation ? "created" : "updated"
        } successfully.`
      );

      if (isOperationSuccessful) {
        if (isDealClone) {
          this.$router.push({
            path: "/deal_create",
            query: { dealType: "STACR_ACIS", dealId: this.createdDealId },
          });
        }
      }
    },
    async deleteDeal() {
      const dealName = this.modelStacr.Name$;
      if (
        !(await this.$root.confirmCurrentStep(
          `Do you want to delete deal: ${dealName}`
        ))
      ) {
        return;
      }
      const result = await withUINotification.bind(this)(async () => {
        await service.deleteCustomDeal(this.dealId$);
      }, `Failed to delete the deal ${dealName}`);
      if (result) {
        await this.$root.redirectToDealCatalog();
      }
    },
    async exportDealToODF() {
      const dealName = this.modelStacr.Name$ || "STACR_ACIS 2022-00-GENERIC";
      await withUINotification.bind(this)(async () => {
        const response = await service.getCustomDeal(this.dealId$, true);
        AxiosSaveContentToFile(`${dealName}.ODF`, response);
      }, `Failed to export the deal.`);
    },
    async exportDealToXLSX() {
      const { data } = await axios.get("model_template.xlsx", {
        responseType: "arraybuffer",
        headers: {
          "Cache-Control": "public; max-age=120",
        },
      });
      const xlsxReadingOptions = {
        type: "buffer",
        cellNF: true,
        cellDateS: true,
      };

      const stacr = this.modelStacr.getRawFieldsFormattedForBackEnd();
      const acis = this.modelAcis.getRawFieldsFormattedForBackEnd();

      var wb = XLSX.read(data, xlsxReadingOptions);

      const dealInfoWs = wb.Sheets["DlInfo"];

      cw.text(dealInfoWs, "C9", stacr.Name);
      cw.date(
        dealInfoWs,
        "C10",
        this.modelStacr.ContractInformation.ClosingDate$
      );
      cw.date(
        dealInfoWs,
        "C11",
        this.modelStacr.ContractInformation.FirstPayDate$
      );
      cw.date(
        dealInfoWs,
        "C12",
        this.modelStacr.ContractInformation.MaturityDate$
      );
      cw.pct(
        dealInfoWs,
        "C14",
        this.modelStacr.ContractInformation.CancellationPct$
      );
      cw.date(
        dealInfoWs,
        "C15",
        this.modelStacr.ContractInformation.EarlyRedemptionDate$
      );

      cw.pct(dealInfoWs, "K9", stacr.Structure.DlqTarget);
      cw.number(dealInfoWs, "K10", stacr.Structure.DlqMonthsAverage);
      cw.pct(dealInfoWs, "Q5", stacr.Structure.CETarget);

      const yearSeniorPrepayWithLossTest = [
        0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3,
      ];
      const yearSeniorPrepayWithoutLossTest = [
        99.0, 99.0, 99.0, 99.0, 99.0, 99.0, 99.0, 99.0, 99.0, 99.0, 0, 0, 0,
      ];

      const yearSeniorPrepay = stacr.Structure.UseCumLossTest
        ? yearSeniorPrepayWithLossTest
        : yearSeniorPrepayWithoutLossTest;
      for (var [idx, value] of yearSeniorPrepay.entries()) {
        const rowIdx = `Q${8 + idx}`;
        cw.pct(dealInfoWs, rowIdx, value);
        dealInfoWs[rowIdx].f = undefined;
      }

      const collateralWs = wb.Sheets["Collateral"];
      for (var [idx, value] of stacr.CollateralInformation.slice(
        0,
        5
      ).entries()) {
        const rowIdx = `${16 + idx}`;
        cw.text(collateralWs, "B" + rowIdx, `Loan_${idx + 1}`);
        cw.decimalNumber(
          collateralWs,
          "F" + rowIdx,
          value.ReferencePoolBalance
        );
        cw.decimalNumber(
          collateralWs,
          "G" + rowIdx,
          value.ReferencePoolBalance
        );

        cw.pct(collateralWs, "H" + rowIdx, value.Wac);
        cw.decimalNumber(collateralWs, "I" + rowIdx, value.Wam);
        cw.decimalNumber(collateralWs, "J" + rowIdx, value.Wala);

        cw.pct(collateralWs, "K" + rowIdx, value.Wac - 0.25);
        cw.number(collateralWs, "L" + rowIdx, 1);
      }

      const bondsWs = wb.Sheets["Bonds"];
      for (var [idx, value] of stacr.Liability.slice(0, 10).entries()) {
        const summaryRowIdx = `${5 + idx}`;
        const rowIdx = `${16 + idx}`;
        cw.text(bondsWs, "E" + summaryRowIdx, value.BondName);
        cw.text(bondsWs, "B" + rowIdx, value.BondName);
        cw.text(
          bondsWs,
          "C" + rowIdx,
          `XXXXXXXX${("0" + (idx + 1)).slice(-2)}`
        );
        cw.date(
          bondsWs,
          "D" + rowIdx,
          this.modelStacr.ContractInformation.ClosingDate$
        );
        cw.number(bondsWs, "E" + rowIdx, 24);
        cw.decimalNumber(bondsWs, "F" + rowIdx, value.Balance);
        cw.pct(bondsWs, "G" + rowIdx, value.Coupon);
        cw.pct(
          bondsWs,
          "H" + rowIdx,
          this.modelStacr.ContractInformation.MaturityDate$
        );
        cw.number(bondsWs, "I" + rowIdx, 365);
        cw.number(bondsWs, "J" + rowIdx, 360);
        cw.text(bondsWs, "M" + rowIdx, idx === 0 ? "Y" : "");
        cw.text(bondsWs, "N" + rowIdx, idx !== 0 ? "Y" : "");
        cw.text(
          bondsWs,
          "Q" + rowIdx,
          idx !== 0 && idx !== stacr.Liability.length - 1 ? "Y" : ""
        );
      }

      const groupsWs = wb.Sheets["Groups"];
      const testsWs = wb.Sheets["Tests"];
      const startBondNameRATEPairsColumnCode = "A".charCodeAt(0); //A+2 = C, A+2+1=D
      for (var [idx, value] of stacr.Liability.entries()) {
        const rowIdx = `${17 + idx}`;
        const testsRowIdx = `${6 + idx}`;
        if (idx == 0) {
          continue;
        }
        const bondNameCellAddress =
          String.fromCharCode(startBondNameRATEPairsColumnCode + idx * 2) +
          "17";
        const rataCellAddress =
          String.fromCharCode(startBondNameRATEPairsColumnCode + idx * 2 + 1) +
          "17";
        cw.text(groupsWs, bondNameCellAddress, value.BondName);
        cw.text(groupsWs, rataCellAddress, "RATA");

        cw.text(groupsWs, "B" + rowIdx, "SUB" + idx);
        cw.text(groupsWs, "C" + rowIdx, value.BondName);

        cw.text(testsWs, "D" + testsRowIdx, value.BondName);
        if (idx !== stacr.Liability.length - 1) {
          cw.pct(testsWs, "E" + testsRowIdx, 100);
        }
      }

      XLSX.writeFile(wb, `${stacr.Name} QUICK MODEL.xlsx`, { cellDates: true });
      return;
    },
    formatNumber(value, event) {
      const minSignsAfterDot =
        event?.target?.attributes?.minSignsAfterDot?.nodeValue || 2;
      const maxSignsAfterDot =
        event?.target?.attributes?.maxSignsAfterDot?.nodeValue || 8;
      let result = formatter.formatAsNumber(value || 0, {
        minSignsAfterDot,
        maxSignsAfterDot,
      });
      if (result == null) {
        result = Number(0).toLocaleString("us-US", {
          minimumFractionDigits: minSignsAfterDot,
          maximumFractionDigits: maxSignsAfterDot,
        });
      }
      return result;
    },
  },
  components: {
    Datepicker,
  },
};
</script>

<style scoped>
.buttons_row-button {
  width: 100px;
}
.buttons_row--spaced {
  margin-right: 2px;
  margin-bottom: 2px;
}
</style>
